import React from 'react';
import { Router } from '@abyss/web/ui/Router';

export const Proto = () => {
  return (
    <React.Fragment>
      <style>
        {`
        /* prototype structure code */
.protoWrap {
  max-width: 1272px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-top: 60px;
  margin-bottom: 60px;
  margin-inline: auto;
}

/* Profile Bar */

.profileBar {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  width: 100%;
  background: #EEF8FB;
  border-radius: 16px;
  font-weight: 500;
}

.profileBar__section {
  padding: 16px 24px;
}

.first {
  position: relative;
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 10px 20px;
  background: #002677;
  color: #fff;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}

.first svg {
  display: block;
}

.bold {
  font-weight: 700;
}

.green {
  color: #007000;
}

.profileBar__copy {
  display: flex;
  gap: 5px;
  align-items: center;
  margin-top: 5px;
  cursor: pointer;
  color: #fff;
  appearance: none;
}

.profileBar__copyIcon {
  border: 1px solid transparent;
}

.profileBar__copy:hover {
  .profileBar__copyIcon {
    border: 1px solid #fff;
  }
}

.profileBar__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
}

.profileBar__list li {
  display: flex;
  gap: 5px;
  align-items: center;
  flex-wrap: wrap;
}

.border {
  position: relative;
}

.border:before {
  content: "";
  display: block;
  width: 1px;
  height: 100%;
  background: #CBCCCD;
  position: absolute;
  left: -24px;
}

.copyPill {
  position: absolute;
  left: 20px;
  bottom: -16px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px 4px 6px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
  color: #323333;
  font-weight: 500;
}

`}
      </style>
      <Router.MetaTags title="Home" />
      <div className="protoWrap">
        <div className="profileBar">
          <div className="profileBar__section first">
            <div className="profileBar__section__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="profileBar__section__content">
              <div className="bold">
                [MEMBER WITH A LONG FIRST AND/OR LAST NAME]
              </div>
              <button className="profileBar__copy">
                <div className="profileBar__copyIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M7.5 15C7.04167 15 6.64931 14.8368 6.32292 14.5104C5.99653 14.184 5.83333 13.7917 5.83333 13.3334V3.33335C5.83333 2.87502 5.99653 2.48266 6.32292 2.15627C6.64931 1.82988 7.04167 1.66669 7.5 1.66669H15C15.4583 1.66669 15.8507 1.82988 16.1771 2.15627C16.5035 2.48266 16.6667 2.87502 16.6667 3.33335V13.3334C16.6667 13.7917 16.5035 14.184 16.1771 14.5104C15.8507 14.8368 15.4583 15 15 15H7.5ZM7.5 13.3334H15V3.33335H7.5V13.3334ZM4.16667 18.3334C3.70833 18.3334 3.31597 18.1702 2.98958 17.8438C2.66319 17.5174 2.5 17.125 2.5 16.6667V5.83335C2.5 5.59724 2.57986 5.39933 2.73958 5.2396C2.89931 5.07988 3.09722 5.00002 3.33333 5.00002C3.56944 5.00002 3.76736 5.07988 3.92708 5.2396C4.08681 5.39933 4.16667 5.59724 4.16667 5.83335V16.6667H12.5C12.7361 16.6667 12.934 16.7465 13.0938 16.9063C13.2535 17.066 13.3333 17.2639 13.3333 17.5C13.3333 17.7361 13.2535 17.934 13.0938 18.0938C12.934 18.2535 12.7361 18.3334 12.5 18.3334H4.16667Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="bold">UUID</div>
              </button>
            </div>
            <div className="copyPill">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M8.83329 11.5L7.04163 9.70829C6.88885 9.55552 6.6944 9.47913 6.45829 9.47913C6.22218 9.47913 6.02774 9.55552 5.87496 9.70829C5.72218 9.86107 5.64579 10.0555 5.64579 10.2916C5.64579 10.5277 5.72218 10.7222 5.87496 10.875L8.24996 13.25C8.41663 13.4166 8.61107 13.5 8.83329 13.5C9.05552 13.5 9.24996 13.4166 9.41663 13.25L14.125 8.54163C14.2777 8.38885 14.3541 8.1944 14.3541 7.95829C14.3541 7.72218 14.2777 7.52774 14.125 7.37496C13.9722 7.22218 13.7777 7.14579 13.5416 7.14579C13.3055 7.14579 13.1111 7.22218 12.9583 7.37496L8.83329 11.5ZM9.99996 18.3333C8.84718 18.3333 7.76385 18.1145 6.74996 17.677C5.73607 17.2395 4.85413 16.6458 4.10413 15.8958C3.35413 15.1458 2.76038 14.2638 2.32288 13.25C1.88538 12.2361 1.66663 11.1527 1.66663 9.99996C1.66663 8.84718 1.88538 7.76385 2.32288 6.74996C2.76038 5.73607 3.35413 4.85413 4.10413 4.10413C4.85413 3.35413 5.73607 2.76038 6.74996 2.32288C7.76385 1.88538 8.84718 1.66663 9.99996 1.66663C11.1527 1.66663 12.2361 1.88538 13.25 2.32288C14.2638 2.76038 15.1458 3.35413 15.8958 4.10413C16.6458 4.85413 17.2395 5.73607 17.677 6.74996C18.1145 7.76385 18.3333 8.84718 18.3333 9.99996C18.3333 11.1527 18.1145 12.2361 17.677 13.25C17.2395 14.2638 16.6458 15.1458 15.8958 15.8958C15.1458 16.6458 14.2638 17.2395 13.25 17.677C12.2361 18.1145 11.1527 18.3333 9.99996 18.3333Z"
                    fill="#007000"
                  />
                </svg>
              </div>
              <div>Copied</div>
            </div>
          </div>
          <div className="profileBar__section">
            <ul className="profileBar__list">
              <li>
                <div className="bold">Medicare Number:</div>
                <div>#xx#x##xx##</div>
              </li>
              <li>
                <div className="bold">Medicare Eligible:</div>
                <div>Part A and Part B</div>
              </li>
              <li>
                <div className="bold">Medicare Number:</div>
                <div>593728104652</div>
              </li>
            </ul>
          </div>
          <div className="profileBar__section">
            <ul className="profileBar__list border">
              <li>
                <div className="bold">Current Status:</div>
                <div>Prospective Member</div>
              </li>
              <li>
                <div className="bold">HSID Complete:</div>
                <div className="green bold">Auth Mbr.</div>
              </li>
              <li>
                <div className="bold">DOB:</div>
                <div>6/24/1958</div>
              </li>
            </ul>
          </div>
          <div className="profileBar__section">
            <ul className="profileBar__list border">
              <li>
                <div className="bold">LIS Level:</div>
                <div className="green bold">1</div>
              </li>
              <li>
                <div className="bold">Medicade Level:</div>
                <div>Full</div>
              </li>
              <li>
                <div className="bold">SSBCI:</div>
                <div>Confirmed - 2/1/2026</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
